import React from 'react';
import DragList from "./DragList";

function BoardViewComponent(props) {
  return <DragList dateStatusSelected={props.dateStatusSelected} handleOpen={props.handleOpen} planTypeValue={props.planTypeValue} handleChangeBoard={props.handleChangeBoard}/>;
}

export default BoardViewComponent;
